export const about = {
    info: "Junte-se a uma comunidade que valoriza suas habilidades e dedicação! Ao se tornar parte da nossa rede, você terá acesso a uma série de benefícios exclusivos que impulsionarão sua carreira e seu sucesso. Confira alguns dos muitos benefícios que você desfrutará ao se unir a nós:",
    name: "Parceirando",
    age: "26 year",
    language: "English, spanish",
    phone: "+00 9876543210",
    email: "example@gmail.com",
    address: "Ruami Mello Moraes, - Salvador - MA 40352, Brazil.",
    title: "Ser um afiliado não é apenas uma oportunidade de ganhar dinheiro",
    description: "Receba comissões generosas por cada venda realizada através do seu link ou cupom de afiliado. Quanto mais você vende, maiores são os seus ganhos. Você será recompensado de forma justa pelo seu esforço e desempenho. Aproveite esta oportunidade para transformar suas habilidades em uma fonte de renda consistente e crescente. Além disso, você terá acesso a relatórios detalhados para monitorar suas vendas e otimizar suas estratégias, garantindo sempre o máximo retorno.",
    font: "Fonte de dados demonstradas: google, chatgpt",
    services: [
        {
            title: "Consumidores",
            persontin: "92",
            description: "Confiam em recomendações de afiliados tanto quanto confiam em recomendações pessoais."
        },
        {
            title: "Clientes",
            persontin: "85",
            description: "São adquiridos através de estratégias de marketing de afiliados."
        },
        {
            title: "Vendas",
            persontin: "75",
            description: "As vendas online são amplamente influenciadas por conteúdos de afiliados."
        },
        {
            title: "Confiança",
            persontin: "80",
            description: "Consumidores são mais propensos a comprar com recomendações de afiliados."
        },
    ],
}